module.exports = __webpack_public_path__ + "img/book.39caad9f.png";